module.exports = __webpack_public_path__ + "public/img/zhbg1.5c84461d.jpg";